import FIKA from "assets/images/icons/fika-icon.svg";
import TRENT from "assets/images/icons/trent-icon.svg";
import GENERICO from "assets/images/icons/generico-icon.svg";
import SINASIGNAR from "assets/images/icons/sinAsignar-icon.svg";
import FEMMTO from "assets/images/icons/femmto-icon.svg";

export const brandIcons = {
  FIKA: FIKA,
  TRENT: TRENT,
  GENERICO: GENERICO,
  "SIN ASIGNAR": SINASIGNAR,
  FEMMTO: FEMMTO,
};

export const COLUMNS_TO_FILTER = [
  { data: "thumbnail", label: "Foto" },
  { data: "sku", label: "SKU" },
  { data: "itemid", label: "Marketplace ID" },
  { data: "typeofcampaign", label: "Tipo de campaña" },
  { data: "promotionname", label: "Promocion" },
  { data: "validity", label: "Vigencia" },
  { data: "status", label: "Estado" },
  { data: "priceregular", label: "PVP" },
  { data: "discountseller", label: "Descuento seller" },
  { data: "priceoffer", label: "PVP Disbyte" },
  { data: "publicprice", label: "PVP Buyer" },
  { data: "rebate", label: "Rebate" },
  { data: "margen", label: "Margen %" },
  { data: "roi", label: "ROI" },
];

export const INITIAL_COLUMNS_STATE = {
  thumbnail: true,
  sku: true,
  itemid: true,
  buybox: true,
  typeofcampaign: true,
  promotionname: true,
  validity: true,
  status: true,
  priceregular: true,
  discountseller: true,
  priceoffer: true,
  publicprice: true,
  rebate: true,
  margen: true,
  roi: true,
};

export const TIME_RANGE_OPTIONS = [
  { value: "today", label: "Hoy" },
  { value: "yesterday", label: "Ayer" },
  { value: "todayAndYesterday", label: "Hoy y Ayer" },
  { value: "next7Days", label: "Proximos 7 días" },
  { value: "next14Days", label: "Proximos 14 días" },
  { value: "next30Days", label: "Proximos 30 días" },
  { value: "next45Days", label: "Proximos 45 días" },
  { value: "thisWeek", label: "Esta semana" },
  { value: "thisMonth", label: "Este mes" },
  { value: "custom", label: "Personalizado" },
];

// Orden fijo solicitado. El filtro matchea tanto contra campaing_type (tipo real) como
// contra promotion_type_show (ver DealsTool.js). LIGHTNING-RBT / ODD / DXI son tipos "a
// mostrar" derivados de PRE_NEGOTIATED (promotion_type_show); LIGHTNING/DOD/SMART/DEAL/
// SELLER_CAMPAIGN son tipos reales (campaing_type). 'ODD' diferencia el bucket
// PRE_NEGOTIATED ≤24h del DOD real (promotion_type='DOD'), por eso conviven ambos.
export const TYPEOFCAMPAIGNS = [
  { value: "LIGHTNING", label: "LIGHTNING" },
  { value: "LIGHTNING-RBT", label: "LIGHTNING-RBT" },
  { value: "ODD", label: "ODD" },
  { value: "DOD", label: "DOD" },
  { value: "DXI", label: "DXI" },
  { value: "SMART", label: "SMART" },
  { value: "DEAL", label: "DEAL" },
  { value: "SELLER_CAMPAIGN", label: "SELLER_CAMPAIGN" },
];

export const STATUSES = [
  { value: "STARTED", label: "Activa" },
  // { value: "CANDIDATE", label: "Candidato" },
  { value: "CANDIDATE", label: "Elegible" },
  { value: "PENDING", label: "Programada" },
];

export const MELI_STATUSES = [
  { value: "Confirmado", label: "Publicada" },
  { value: "Pendiente", label: "Pendiente" },
  { value: "ERROR", label: "Error de envío" },
];
